import { useEffect, useState } from 'react';
import { getLoggedInUser } from '../../helpers/api_helper';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../slices/thunks';
import { createSelector } from 'reselect';

const useUser = () => {
	const selectorProfile = createSelector(
        state => state.Profile,
        profile => ({
            user: profile.user
        })
    );

    const { user } = useSelector(selectorProfile);

	return { user };
}

const useLoggedUser = () => {
	const userProfileSession = getLoggedInUser();
	const [userProfile, setUserProfile] = useState(userProfileSession ? userProfileSession : null);
	return { userProfile };
}

const useProfile = () => {
	const dispatch = useDispatch(); 
	const userProfileSession = getLoggedInUser();
	const [token, setToken] = useState(userProfileSession && userProfileSession['access_token']);
	const [loading, setLoading] = useState(userProfileSession ? false : true);
	const [userProfile, setUserProfile] = useState(userProfileSession ? userProfileSession : null);
	
	useEffect(() => {
		const userProfileSession = getLoggedInUser();
		setUserProfile(userProfileSession);
		setLoading(token ? false : true);
	}, []);

	useEffect(() => {
		if (token) {
			if (userProfileSession['avatar']) {
				const avatar = document.getElementById('avatar');
				if (avatar) {
					avatar.src = userProfileSession['avatar'];
				}
			}
			dispatch(getProfile());
		}
	}, [token]);

	return { userProfile, loading, token};
};

export { useUser, useLoggedUser, useProfile };
